export default "__VITE_ASSET__613dd690__"